// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hXXT","label":"styles_label__1vesv"};